import React from "react";
import DateCellWithExpiration from "../../../../components/data/DateCellWithExpiration";
import TransactionStatus from "../../../../components/elements/general/TransactionStatus";
import HamburgerMenu from "../../../../components/menu/HamburgerMenu";
import HamburgerMenuAction from "../../../../components/menu/HamburgerMenuAction";
import AuthorizeComponent from "../../../../core/AuthorizeComponent";
import OfferStatus from "../../../../core/enums/OfferStatus";
import Roles from "../../../../core/enums/Roles";
import BidGradePriceCell from "../components/BidGradePriceCell";
import GradeCell from "../../../../components/data/GradeCell";
import GreenCell from "../../../../components/data/GreenCell";
import PurchasePrice from "../../../../components/data/PurchasePrice";
import HandlingCell from "../../../../components/data/HandlingCell";
import DateCell from "../../../../components/data/DateCell";

const createSteps = (value, t, original) => {
    const buyer =
        original?.acceptedBidInfo?.bidCompanyName ??
        t("common:status.theBuyer");
    let result = Array.from([
        {
            status: 4,
            title: `${t("common:status.step")}: 1/5 - ${t(
                "common:status.inProgress"
            ).toUpperCase()} `,
            tip: t("common:status.progress_Accept", {
                company: original.offerer,
            }),
        },
        {
            status: 3,
            title: `${t("common:status.step")}: 2/5 - ${t(
                "common:status.pending"
            ).toUpperCase()} `,
            tip: t("common:status.pending_Adeposit", {
                company: buyer,
            }),
        },
        {
            status: 3,
            title: `${t("common:status.step")}: 3/5 - ${t(
                "common:status.pending"
            ).toUpperCase()} `,
            tip: t("common:status.pending_collect", {
                company: buyer,
            }),
        },
        {
            status: 3,
            title: `${t("common:status.step")}: 4/5 - ${t(
                "common:status.pending"
            ).toUpperCase()} `,
            tip: t("common:status.pending_test", {
                company: buyer,
            }),
        },
        {
            status: 3,
            title: `${t("common:status.step")}: 5/5 - ${t(
                "common:status.pending"
            ).toUpperCase()} `,
            tip: t("common:status.pending_confirmTest", {
                company: original.offerer,
            }),
        },
    ]);
    switch (value) {
        case OfferStatus.waitingForOffererFunds:
            result[0] = {
                status: 4,
                title: `${t("common:status.step")}: 1/5 - ${t(
                    "common:status.inProgress"
                ).toUpperCase()} `,
                tip: t("common:status.progress_Cdeposit", {
                    company: original.offerer,
                }),
            };
            break;
        case OfferStatus.offererEscrowedFunds:
            result[0] = {
                status: 1,
                title: `${t("common:status.step")}: 1/5 - ${t(
                    "common:status.completed"
                ).toUpperCase()} `,
                tip: t("common:status.completed_Cdeposit", {
                    company: original.offerer,
                }),
            };
            result[1] = {
                status: 4,
                title: `${t("common:status.step")}: 2/5 - ${t(
                    "common:status.inProgress"
                ).toUpperCase()} `,
                tip: t("common:status.progress_Adeposit", {
                    company: buyer,
                }),
            };
            break;
        case OfferStatus.buyerEscrowedFunds:
            result[0] = {
                status: 1,
                title: `${t("common:status.step")}: 1/5 - ${t(
                    "common:status.completed"
                ).toUpperCase()} `,
                tip: t("common:status.completed_Cdeposit", {
                    company: original.offerer,
                }),
            };
            result[1] = {
                status: 1,
                title: `${t("common:status.step")}: 2/5 - ${t(
                    "common:status.completed"
                ).toUpperCase()} `,
                tip: t("common:status.completed_Adeposit", {
                    company: buyer,
                }),
            };
            result[2] = {
                status: 4,
                title: `${t("common:status.step")}: 3/5 - ${t(
                    "common:status.inProgress"
                ).toUpperCase()} `,
                tip: t("common:status.progress_collect", {
                    company: buyer,
                }),
            };
            break;
        case OfferStatus.buyerClaimedBottles:
            result[0] = {
                status: 1,
                title: `${t("common:status.step")}: 1/5 - ${t(
                    "common:status.completed"
                ).toUpperCase()} `,
                tip: t("common:status.completed_Cdeposit", {
                    company: original.offerer,
                }),
            };
            result[1] = {
                status: 1,
                title: `${t("common:status.step")}: 2/5 - ${t(
                    "common:status.completed"
                ).toUpperCase()} `,
                tip: t("common:status.completed_Adeposit", {
                    company: buyer,
                }),
            };
            result[2] = {
                status: 1,
                title: `${t("common:status.step")}: 3/5 - ${t(
                    "common:status.completed"
                ).toUpperCase()} `,
                tip: t("common:status.completed_collect", {
                    company: buyer,
                }),
            };
            result[3] = {
                status: 4,
                title: `${t("common:status.step")}: 4/5 - ${t(
                    "common:status.inProgress"
                ).toUpperCase()} `,
                tip: t("common:status.progress_test", {
                    company: buyer,
                }),
            };
            break;
        case OfferStatus.qualityTested:
            result[0] = {
                status: 1,
                title: `${t("common:status.step")}: 1/5 - ${t(
                    "common:status.completed"
                ).toUpperCase()} `,
                tip: t("common:status.completed_Cdeposit", {
                    company: original.offerer,
                }),
            };
            result[1] = {
                status: 1,
                title: `${t("common:status.step")}: 2/5 - ${t(
                    "common:status.completed"
                ).toUpperCase()} `,
                tip: t("common:status.completed_Adeposit", {
                    company: buyer,
                }),
            };
            result[2] = {
                status: 1,
                title: `${t("common:status.step")}: 3/5 - ${t(
                    "common:status.completed"
                ).toUpperCase()} `,
                tip: t("common:status.completed_collect", {
                    company: buyer,
                }),
            };
            result[3] = {
                status: 1,
                title: `${t("common:status.step")}: 4/5 - ${t(
                    "common:status.completed"
                ).toUpperCase()} `,
                tip: t("common:status.completed_test", {
                    company: buyer,
                }),
            };
            result[4] = {
                status: 4,
                title: `${t("common:status.step")}: 5/5 - ${t(
                    "common:status.inProgress"
                ).toUpperCase()} `,
                tip: t("common:status.progress_confirmTest", {
                    company: original.offerer,
                }),
            };

            break;
        case 99:
            result[0] = {
                status: 1,
                title: `${t("common:status.step")}: 1/5 - ${t(
                    "common:status.completed"
                ).toUpperCase()} `,
                tip: t("common:status.completed_Cdeposit", {
                    company: original.offerer,
                }),
            };
            result[1] = {
                status: 1,
                title: `${t("common:status.step")}: 2/5 - ${t(
                    "common:status.completed"
                ).toUpperCase()} `,
                tip: t("common:status.completed_Adeposit", {
                    company: buyer,
                }),
            };
            result[2] = {
                status: 1,
                title: `${t("common:status.step")}: 3/5 - ${t(
                    "common:status.completed"
                ).toUpperCase()} `,
                tip: t("common:status.completed_collect", {
                    company: buyer,
                }),
            };
            result[3] = {
                status: 1,
                title: `${t("common:status.step")}: 4/5 - ${t(
                    "common:status.completed"
                ).toUpperCase()} `,
                tip: t("common:status.completed_test", {
                    company: buyer,
                }),
            };
            result[4] = {
                status: 1,
                title: `${t("common:status.step")}: 5/5 - ${t(
                    "common:status.completed"
                ).toUpperCase()} `,
                tip: t("common:status.completed_confirmTest", {
                    company: original.offerer,
                }),
            };
            break;
        default:
            break;
    }
    return result;
};

const MyOffersColumns = {
    getColumns: (
        offerStatus,
        t,
        actions,
        currentLanguage,
        globalState,
        setOpenAccordionId
    ) => {
        const acceptedColumns = [
            {
                Header: t("table:headers.gasType"),
                accessor: "refrigerantGasTypeCode",
                Cell: GreenCell,
            },
            {
                Header: t("table:headers.gasQuantity"),
                accessor: "quantity",
                Cell: ({ cell: { value } }) =>
                    GreenCell({ cell: { value: value.toFixed(2) + " kg" } }),
            },
            {
                Header: t("table:headers.grade"),
                accessor: "pressumedGradeName",
                Cell: GradeCell,
            },
            {
                Header: t("table:headers.evaluation"),
                accessor: "analysisDone",
                Cell: ({ cell: { value } }) =>
                    !value
                        ? t("filters:analysis.measurement")
                        : t("filters:analysis.selfAssessment"),
            },
            {
                Header: `${t("table:headers.bidAmounts")}/${t(
                    "sidebar:label.extraction.qualityGrade"
                )}`,
                accessor: "offeredPrices",
                Cell: BidGradePriceCell,
            },
            {
                Header: t("table:headers.handlingCosts"),
                accessor: "acceptedBidInfo",
                Cell: ({ cell: { value } }) =>
                    HandlingCell(
                        value?.handlingCosts || 0,
                        setOpenAccordionId,
                        "bid.details"
                    ),
            },
            {
                Header: t("stockListing.headers.dealExpiration"),
                accessor: "dealExpiration",
                Cell: (value) => {
                    let translation = "";
                    const offerStatus = value.row.original.status;
                    if (offerStatus === 2) {
                        translation = "screens:myOffers.offerStatus.2";
                    } else if (offerStatus === 3) {
                        translation = "screens:myOffers.offerStatus.3";
                    } else if (offerStatus === 4) {
                        translation = "screens:myOffers.offerStatus.4";
                    }
                    return DateCellWithExpiration(value, translation);
                },
            },
            {
                Header: t("table:headers.status"),
                accessor: "status",
                disableSortBy: true,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <TransactionStatus
                        steps={createSteps(value, t, original)}
                    />
                ),
            },
            {
                Header: "",
                accessor: "offerId",
                Cell: ({ cell: { value }, row: { original } }) => {
                    const dateTimeNow = new Date();
                    return (
                        <AuthorizeComponent
                            roles={[
                                Roles.InstallerCompanyAdmin,
                                Roles.InstallerCompanyUser,
                            ]}
                        >
                            <HamburgerMenu>
                                <HamburgerMenuAction
                                    disabled={
                                        new Date(original.dealExpiration) >
                                        dateTimeNow
                                    }
                                    text={t("actions:rejectBid")}
                                    onClick={async () => {
                                        actions.rejectToggleOpen([original]);
                                    }}
                                />
                                {original.status === 2 && (
                                    <HamburgerMenuAction
                                        disabled={
                                            !globalState.hasValidCompanyCertificate |
                                            !globalState.hasCertificateRights
                                        }
                                        text={t(
                                            "actions:dialogs.transactionDetails.title"
                                        )}
                                        onClick={async () => {
                                            await actions.getTransactionDetails(
                                                original,
                                                original.acceptedBid.id
                                            );
                                        }}
                                    />
                                )}
                            </HamburgerMenu>
                        </AuthorizeComponent>
                    );
                },
            },
        ];

        const pendingColumns = [
            {
                Header: t("table:headers.gasType"),
                accessor: "refrigerantGasTypeCode",
                Cell: GreenCell,
            },
            {
                Header: t("table:headers.gasQuantity"),
                accessor: "quantity",
                Cell: ({ cell: { value } }) =>
                    GreenCell({ cell: { value: value.toFixed(2) + " kg" } }),
            },
            {
                Header: t("table:headers.grade"),
                accessor: "pressumedGradeName",
                Cell: GradeCell,
            },
            {
                Header: t("table:headers.evaluation"),
                accessor: "analysisDone",
                Cell: ({ cell: { value } }) =>
                    !value
                        ? t("filters:analysis.measurement")
                        : t("filters:analysis.selfAssessment"),
            },
            {
                Header: t("table:headers.numBids"),
                accessor: "totalOffers",
            },
            {
                Header: t("table:headers.status"),
                accessor: "status",
                disableSortBy: true,
                Cell: ({ cell: { value }, row: { original } }) =>
                    original.totalOffers > 0 && (
                        <TransactionStatus
                            steps={createSteps(value, t, original)}
                        />
                    ),
            },
            {
                Header: "",
                accessor: "offerId",
                Cell: ({ cell: { value }, row: { original } }) => (
                    <AuthorizeComponent
                        roles={[
                            Roles.InstallerCompanyAdmin,
                            Roles.InstallerCompanyUser,
                        ]}
                    >
                        <HamburgerMenu>
                            <HamburgerMenuAction
                                text={t("actions:unpublishFromMarketplace")}
                                onClick={async () => {
                                    actions.toggleOpen({
                                        offerIds: [value],
                                        original,
                                    });
                                }}
                            />
                        </HamburgerMenu>
                    </AuthorizeComponent>
                ),
            },
        ];

        const qualityColumns = [
            {
                Header: t("table:headers.gasType"),
                accessor: "refrigerantGasTypeCode",
                Cell: GreenCell,
            },
            {
                Header: t("table:headers.gasQuantity"),
                accessor: "quantity",
                Cell: ({ cell: { value } }) =>
                    GreenCell({ cell: { value: value.toFixed(2) + " kg" } }),
            },
            {
                Header: t("table:headers.grade"),
                accessor: "pressumedGradeName",
                Cell: GradeCell,
            },
            {
                Header: t("table:headers.evaluation"),
                accessor: "analysisDone",
                Cell: ({ cell: { value } }) => (value ? "Yes" : "No"),
            },
            {
                Header: `${t("table:headers.bidAmounts")}/${t(
                    "sidebar:label.extraction.qualityGrade"
                )}`,
                accessor: "offeredPrices",
                Cell: BidGradePriceCell,
            },
            {
                Header: t("table:headers.handlingCosts"),
                accessor: "acceptedBidInfo",
                Cell: ({ cell: { value } }) =>
                    HandlingCell(
                        value?.handlingCosts || 0,
                        setOpenAccordionId,
                        "bid.details"
                    ),
            },
            {
                Header: t("table:headers.purchasePrice"),
                accessor: "confirmedQuality",
                Cell: ({ cell: { row } }) => {
                    let prices = {
                        A: row.original.acceptedBid?.offeredPriceGradeA,
                        B: row.original.acceptedBid?.offeredPriceGradeB,
                        C: row.original.acceptedBid?.offeredPriceGradeC,
                    };
                    return PurchasePrice({
                        row,
                        t,
                        currentLanguage,
                        globalState,
                        prices,
                    });
                },
            },
            {
                Header: t("table:headers.dealExpiration"),
                accessor: "dealExpiration",
                Cell: (value) => {
                    let translation = "";
                    const offerStatus = value.row.original.status;
                    if (offerStatus === 5) {
                        translation = "screens:myOffers.offerStatus.5";
                    }
                    const onHold =
                        offerStatus === 10 ? t("common:status.onHold") : null;
                    return DateCellWithExpiration(value, translation, onHold);
                },
            },
            {
                Header: t("table:headers.status"),
                accessor: "status",
                disableSortBy: true,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <TransactionStatus
                        inDispute={
                            original.status === 10
                                ? t("common:status.inDispute")
                                : null
                        }
                        steps={createSteps(value, t, original)}
                    />
                ),
            },
            {
                Header: "",
                accessor: "offerId",
                Cell: ({ cell: { value }, row: { original } }) => {
                    const dateTimeNow = new Date();
                    return (
                        <AuthorizeComponent
                            roles={[
                                Roles.InstallerCompanyAdmin,
                                Roles.InstallerCompanyUser,
                            ]}
                        >
                            <HamburgerMenu>
                                <HamburgerMenuAction
                                    disabled={
                                        !(
                                            original.status ===
                                                OfferStatus.qualityTested ||
                                            (original.status ===
                                                OfferStatus.buyerClaimedBottles &&
                                                original.dealExpiration <
                                                    dateTimeNow.toISOString())
                                        ) |
                                        (original.status ===
                                            OfferStatus.qualityTested &&
                                            original.dealExpiration >
                                                dateTimeNow.toISOString() &&
                                            (!globalState.hasValidCompanyCertificate ||
                                                !globalState.hasCertificateRights))
                                    }
                                    text={t("actions:finishTransaction")}
                                    onClick={async () => {
                                        actions.sellToggleOpen([original]);
                                    }}
                                />
                                {/* <HamburgerMenuAction
                                    disabled={!(original.status === OfferStatus.qualityTested || (original.status ===
                                        OfferStatus.buyerClaimedBottles &&
                                        original.dealExpiration <
                                        dateTimeNow.toISOString()))
                                    }
                                    text={t("actions:dispute.start")}
                                    onClick={async () => {
                                        actions.openDisputeWizard(original);
                                    }}
                                /> */}
                            </HamburgerMenu>
                        </AuthorizeComponent>
                    );
                },
            },
        ];
        const soldColumns = [
            {
                Header: t("table:headers.gasType"),
                accessor: "confirmedRefrigerantGasTypeCode",
                Cell: GreenCell,
            },
            {
                Header: t("table:headers.gasQuantity"),
                accessor: "confirmedQuantity",
                Cell: ({ cell: { value } }) =>
                    GreenCell({ cell: { value: value?.toFixed(2) + " kg" } }),
            },
            {
                Header: t("table:headers.grade"),
                accessor: "confirmedGradeName",
                Cell: GradeCell,
            },
            {
                Header: t("table:headers.evaluation"),
                accessor: "analysisDone",
                Cell: ({ cell: { value } }) => (value ? "Yes" : "No"),
            },
            {
                Header: `${t("table:headers.bidAmounts")}/${t(
                    "sidebar:label.extraction.qualityGrade"
                )}`,
                accessor: "offeredPrices",
                Cell: BidGradePriceCell,
            },
            {
                Header: t("table:headers.handlingCosts"),
                accessor: "acceptedBidInfo",
                Cell: ({ cell: { value } }) =>
                    HandlingCell(
                        value?.handlingCosts || 0,
                        setOpenAccordionId,
                        "bid.details"
                    ),
            },
            {
                Header: t("table:headers.purchasePrice"),
                accessor: "confirmedQuality",
                Cell: ({ cell: { row } }) => {
                    let prices = {
                        A: row.original.acceptedBid?.offeredPriceGradeA,
                        B: row.original.acceptedBid?.offeredPriceGradeB,
                        C: row.original.acceptedBid?.offeredPriceGradeC,
                    };
                    return PurchasePrice({
                        row,
                        t,
                        currentLanguage,
                        globalState,
                        prices,
                    });
                },
            },
            {
                Header: t("table:headers.soldDate"),
                accessor: "lastChangeDateTime",
                Cell: DateCell,
            },
            {
                Header: t("table:headers.status"),
                accessor: "status",
                disableSortBy: true,
                Cell: ({ cell: { value }, row: { original } }) => (
                    <TransactionStatus
                        steps={createSteps(value, t, original)}
                    />
                ),
            },
        ];
        if (
            offerStatus.includes(OfferStatus.offererEscrowedFunds) ||
            offerStatus.includes(OfferStatus.buyerEscrowedFunds)
        ) {
            return acceptedColumns;
        } else if (
            offerStatus.includes(OfferStatus.buyerClaimedBottles) ||
            offerStatus.includes(OfferStatus.qualityTested)
        ) {
            return qualityColumns;
        } else if (offerStatus.includes(OfferStatus.sold)) {
            return soldColumns;
        }

        return pendingColumns;
    },
};

export default MyOffersColumns;
